// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import VModal from 'vue-js-modal';
import VueLazyload from 'vue-lazyload'



Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require("@/assets/loader.gif"),
  attempt: 1
})

var bus = new Vue();

Object.defineProperty(Vue.prototype, '$bus', {
  get() {
    return this.$root.bus;
  }
});

Vue.config.productionTip = false



Vue.use(VModal);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data: {
    bus: bus    // Our global event bus
  },
  template: '<App/>',
  components: { App },
})